import { CheckboxDeleteSelectedItem } from '../CheckboxDeleteSelectedItem'

type Operator = { id: number; name: string }

interface CheckboxDeleteSelectedOperatorItemProps<T extends Operator> {
  onDelete: (rows: T[]) => Promise<void> | void
}

export const CheckboxDeleteSelectedOperatorItem = <T extends Operator>({
  onDelete
}: CheckboxDeleteSelectedOperatorItemProps<T>) => (
  <CheckboxDeleteSelectedItem
    onDelete={onDelete}
    renderItem={(row) => `${row.id} (${row.name})`}
    successMessage={(rows) => `${rows.length} Operators deleted successfully`}
    errorMessage={(rows) => `Failed to delete ${rows.length} Operators`}
    confirmationTitle="Delete Selected Operators"
    confirmationMessage="Are you sure you want to delete the following Operators? This action cannot be undone."
  />
)
